import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2148ee3c")

_pushScopeId("data-v-2148ee3c")
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "project-selector" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("chevron_left")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("chevron_right")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MaterialIcon = _resolveComponent("MaterialIcon")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("a", {
      class: "menu-toggle",
      role: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleNavigation && _ctx.toggleNavigation(...args))),
      "aria-label": "Toggle menu"
    }, [
      _createVNode(_component_MaterialIcon, { class: "menu-icon" }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.menuIcon), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode("div", {
      class: "project-title",
      title: _ctx.currentRouteName
    }, _toDisplayString(_ctx.currentRouteName), 9, ["title"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        class: "backward",
        role: "button",
        title: "Navigate backward",
        "aria-label": "Navigate backward",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateBackward && _ctx.navigateBackward(...args))),
        disabled: _ctx.isStartOfRoutes
      }, [
        _createVNode(_component_MaterialIcon, { class: "menu-icon" }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ], 8, ["disabled"]),
      _createVNode("a", {
        class: "forward",
        role: "button",
        title: "Navigate forward",
        "aria-label": "Navigate forward",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateForward && _ctx.navigateForward(...args))),
        disabled: _ctx.isEndOfRoutes
      }, [
        _createVNode(_component_MaterialIcon, { class: "menu-icon" }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ], 8, ["disabled"])
    ])
  ]))
})